<template>
  <div class="success">
    <div class="icon">
      <img src="@/assets/img/成功.png" />
    </div>
    <div>
      <h3>注册成功</h3>
      <p>恭喜您,完成法人注册</p>
    </div>
    <button class="submit" @click="submit()">返回{{count}}</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      count: "" //倒计时
    };
  },
  created() {
    this.goGrdoupRecor();
  },
  methods: {
    goGrdoupRecor() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
            setTimeout(() => {
              this.JSBridge.closeNewWindow();
            }, 1500);
          }
        }, 1000);
      }
    },
    submit() {
      setTimeout(() => {
        this.JSBridge.closeNewWindow();
      }, 1500);
    }
  }
};
</script>

<style lang='less' scoped>
.success {
  text-align: center;
  background: #fff;
  .icon {
    border-radius: 50%;
    margin-top: 30%;
  }
  h3 {
    margin-top: 7%;
    font-size: 18px;
    font-family: AlibabaPuHuiTiM;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 1rem;
  }
  p {
    margin-top: 5px;
    font-size: 15px;
    font-family: AlibabaPuHuiTiR;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
  }
  .submit {
    position: absolute;
    left: 10%;
    bottom: 30%;
    width: 300px;
    height: 45px;
    background: rgba(16, 142, 233, 1);
    border-radius: 6px;
    font-size: 18px;
    font-family: AlibabaPuHuiTiM;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
}
</style>